<template>
    <div>
        <div class="show-navigation">
            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-2">
                            <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                                <i class="material-icons">keyboard_arrow_left</i>
                            </a>
                        </div>

                        <div class="col-8">
                            <h1 class="header__title">Achievements</h1>
                        </div>
                    </div>
                </div>
            </header>

            <div class="container">
                <div v-for="group in achievementGroups" class="panel bg--layer-light mb--20">
                    <div class="profile profile--horizontal mb--md">
                        <figure class="profile__avatar">
                            <span class="profile__avatar__img"><img :src="avatar" alt=""></span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">
                                <router-link :to="{ name: 'achievements', params: { group_id: group.id }}">{{ group.name }}</router-link>
                            </div>
                            <div class="profile__level c--white">{{ group.description }}</div>
                        </div>
                    </div>

                    <div class="progress mb--lg">
                        <div class="progress__bar"><span :style="achievementProgressbar(group)"></span></div>
                        <span class="progress__name">{{ group.unlocked_achievements_count }}/{{ group.achievements_count }} Completed</span>
                    </div>

                    <p v-if="group.id === 1" class="text--center opacity--md"><strong>Group reward</strong></p>

                    <router-link v-if="group.id === 1" class="btn btn--action btn--beam btn--yellow text--sm" :to="'/profile'">
                        Profile customization

                        <div class="btn--action__icon btn--action__icon--normal btn--action__icon--left ml--10">
                            <img src="img/icons/trophy.svg" alt="" />
                        </div>
                        <div class="btn--action__icon btn--action__icon--normal btn--action__icon--right">
                            <img src="img/icons/lock.svg" alt="" />
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import dashboardApi from "../api/dashboard";
    import {mapGetters} from "vuex";
    import internalBackRoute from "../mixins/internalBackRoute";

    export default {
        name: "AchievementGroups",

        mixins: [internalBackRoute],
        components: {Navigation},

        data: function () {
            return {
                achievementGroups: [],
            }
        },

        methods: {
            async loadAchievementGroups() {
                try {
                    let response = await dashboardApi.loadAchievementGroups()

                    this.achievementGroups = response.data.data
                } catch (e) {

                }
            },

            achievementProgressbar(achievementGroup) {
                return 'width: ' + Math.round((achievementGroup.unlocked_achievements_count / achievementGroup.achievements_count) * 100) + '%;'
            }
        },

        computed: {
            ...mapGetters('auth', [
                'avatar'
            ])
        },

        created() {
            this.loadAchievementGroups()
        }
    }
</script>